import { Component, OnInit } from '@angular/core';
import * as bootstrap from "bootstrap";
import * as $AB from 'jquery';
declare const func2: any;


@Component({
  selector: 'app-dataservice',
  templateUrl: './dataservice.component.html',
  styleUrls: ['./dataservice.component.css']
})
export class DataserviceComponent implements OnInit {

   constructor() { }

  ngOnInit(): void {

    func2();

     $('.data_Service').addClass('active');
    $('.data_Service a').css('color','#fff');
    $('.data_Service img').attr('src','./assets/image/icon/Data_Service.png');
    $(".header-title p").text('Data Services');


}

hovercard(){
  $(".info_heading").css('transition','0.5s all'); 
  $(".inner-div").css('transition', '5.5s all');
 }
   hovercard2(){
   $(".info_heading").css('transition','0.65s all');
   $(".inner-div").css('transition', '0.5s all');
   }

}
